// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwUploader-wrap","item":"CwUploader-item","uploadItem":"CwUploader-uploadItem","itemDisabled":"CwUploader-itemDisabled","uploadIcon":"CwUploader-uploadIcon","text":"CwUploader-text","closeIcon":"CwUploader-closeIcon","invalid":"CwUploader-invalid"};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwuploader/CwUploader.scss
// module id = 1047
// module chunks = 10